import SegmentedControl, { type SegmentedControlOption } from './SegmentedControl';

type FilterChipOption = SegmentedControlOption;

interface FilterChipBarProps {
    options: FilterChipOption[];
    value: string;
    onChange: (value: string) => void;
    ariaLabel?: string;
    className?: string;
}

export default function FilterChipBar({
    options,
    value,
    onChange,
    ariaLabel,
    className,
}: FilterChipBarProps) {
    return (
        <SegmentedControl
            options={options}
            value={value}
            onValueChange={onChange}
            ariaLabel={ariaLabel}
            className={className}
        />
    );
}
